import { Injectable } from '@angular/core';
import { IndexedDBConnectorService } from './indexed-dbconnector.service';
import { UtilHttpStatus } from '@formbird/shared';

const logger = console;

@Injectable({
  providedIn: 'root'
})
export class DexieSearchService {

  constructor(
    private indexedDBConnectorService: IndexedDBConnectorService
  ) {
  }

  private getDatabase() {
    return this.indexedDBConnectorService.getDatabase();
  }

  public search(query) {

    const _self = this;

    return new Promise((resolve, reject) => {

      logger.debug('Doing search in DexieSearchService...');

      if (query.dexieSearchFunction) {

        _self.getDatabase().then(function(db) {

          query.dexieSearchFunction(db, function (err, data) {
            if (err) {
              logger.error('Error in Dexie: ');
              logger.error(err);
              reject(err);
            } else {
              const results: any = {
                statusCode: UtilHttpStatus.OK,
                searchProvier: 'dexie',
                data: { data: [] },
                total: 0
              };

              if (data) {
                if (!query.includeAllVersions) {
                  const filtered = data?.filter(doc => doc.systemHeader?.currentVersion === true) || data;
                  results.data = { data: filtered };
                  results.total = filtered.length;
                } else {
                  results.total = data.length;
                  results.data = data;
                }
              }

              resolve(results);
            }
          });
        },(error) => {
          reject(error);
        });

      } else {

        const msg = 'Dexie search not specified for offline querying';
        reject(new Error(msg));
      }

    });
  }
}
